import Api from "../../library/api";
import { showError } from "../snackbars/snackbars-actions";

export const REQUEST_NEW_USER = "REQUEST_NEW_USER";
export const NEW_USER_FAILED = "NEW_USER_FAILED";
export const NEW_USER_SUCCESS = "NEW_USER_SUCCESS";

export function resetNewUser(payload, responseCallback) {
  return dispatch => {
    dispatch({ type: REQUEST_NEW_USER });

    Api.post("p/claim-account", payload, responseCallback).then(resp => {
      if (resp.err) {
        dispatch({ type: NEW_USER_FAILED });
        dispatch(showError(resp.err));
        return;
      } else {
        responseCallback(true);
      }

      // "admin": false,
      // "role": "Owner",
      // "business": true,
      // "business_name": "Enjoy Space"

      resp.permissions = {
        admin: resp.admin
      };

      dispatch({
        type: NEW_USER_SUCCESS,
        payload: resp
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/new-user/new-user-actions.js